import { retrieveRawInitData, retrieveLaunchParams } from '@tma.js/sdk';

/**
 * Тип пользователя Telegram из initData
 */
export interface TelegramUser {
    id: number;
    first_name: string;
    last_name?: string;
    username?: string;
    language_code?: string;
    is_premium?: boolean;
    photo_url?: string;
}

/**
 * Получить raw initData строку из Telegram WebApp
 * @returns initData строка или null, если недоступна
 */
export function getInitData(): string | null {
    try {
        const rawInitData = retrieveRawInitData();
        return rawInitData || null;
    } catch (error) {
        console.warn('Failed to retrieve initData from Telegram SDK:', error);
        return null;
    }
}

/**
 * Получить userId из initData
 * @returns userId или null, если недоступен
 */
export function getUserId(): number | null {
    try {
        const data = retrieveLaunchParams();
        // retrieveLaunchParams возвращает объект с user, но тип может быть не определен
        const user = (data as any)?.user;
        return user?.id || null;
    } catch (error) {
        console.warn('Failed to get userId from initData:', error);
        return null;
    }
}

/**
 * Получить объект пользователя из initData
 * @returns TelegramUser или null, если недоступен
 */
export function getUser(): TelegramUser | null {
    try {
        const data = retrieveLaunchParams();
        // retrieveLaunchParams возвращает объект с user, но тип может быть не определен
        const user = (data as any)?.user;
        if (!user) {
            return null;
        }

        return {
            id: user.id,
            first_name: user.firstName,
            last_name: user.lastName,
            username: user.username,
            language_code: user.languageCode,
            is_premium: user.isPremium,
            photo_url: user.photoUrl,
        };
    } catch (error) {
        console.warn('Failed to get user from initData:', error);
        return null;
    }
}
